import React, { useEffect, useState } from "react";
import { Col, Button, Form } from "react-bootstrap";
import LoadingIco from "../libs/Loading";
import Language from "../../services/Language.js";

const l = new Language();

const Search = (props) => {
  const { url } = props;
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      return setValidated(true);
    }

    props.search(props.value);
  };

  return (
    <div className="search-ctn-frame">
      <div>
        <Form
          noValidate
          validated={validated}
          className="search-input"
          onSubmit={handleSubmit}
        >
          <Form.Control
            type="text"
            value={props.value}
            onChange={props.onTextChange}
            placeholder={l.g("certificate.search_placeholder", "Search by certificate number")}
            onFocus={() => {
              props.onInpFocus();
            }}
            required={true}
          />

          <Button className="ico" type="submit">
            {props.loading ? <LoadingIco /> : <i className="fas fa-search"></i>}
          </Button>
        </Form>
      </div>
      <div className={props.certificate ? "mh-hide-div" : ""}>
        <div className="search-default-frame">
          <img
            src={
              props.isnotfound
                ? "/img/sdk/notfound.svg"
                : "/img/sdk/search-icon-big.svg"
            }
          />
          <p>
            {props.isnotfound
              ? l.g("certificate.not_found_message", "Certificate not found. Please try again with advanced search")
              : l.g("certificate.search_guide_message", "Please search for the certificate by entering it in the search bar to view the certificate")}
          </p>
        </div>
      </div>
    </div>
  );
};
export default Search;
